import React from "react";
import LoginSidebar from "../../components/Login/LoginSidebar";
import { useHistory } from "react-router-dom";

const BuildProfileLayout = (props) => {
  const history = useHistory();

  let cssDec = { height: "116vh" };
  if (history.location.pathname === "/build-profile-success") {
    cssDec = { height: "100vh" };
  }

  return (
    <section className="login-section build-profile" style={cssDec}>
      <div className="lg-left">
        <LoginSidebar />
      </div>
      <div className="lg-right buildprofile-left">{props.children}</div>
    </section>
  );
};

export default BuildProfileLayout;
